import useFilteredVariantTraits from "@insite/client-framework/Common/Hooks/useFilteredVariantTraits";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedProductPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    getProductState,
    getProductStateByPath,
    getVariantChildrenDataView,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import updateVariantSelection from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import translate from "@insite/client-framework/Translate";
import { VariantDisplayTypeValues, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import ProductDetailsVariantButton from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantButton";
import ProductDetailsVariantDropdown from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantDropdown";
import ProductDetailsVariantSwatchDropdown from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchDropdown";
import ProductDetailsVariantSwatchGrid from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchGrid";
import ProductDetailsVariantSwatchList from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link from "@insite/mobius/Link/Link";
import Select, { SelectProps } from "@insite/mobius/Select";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import cenVariantPdpAddToCartClicked from "@tCentro/Handlers/CENPdpVariantAddtoCartHandler";
import CustomAlertIcon from "@tCentro/Icons/CustomAlertIcon";
import CustomAlertTriangleIcon from "@tCentro/Icons/CustomAlertTriangleIcon";
import MinusIcon from "@tCentro/Icons/MinusIcon";
import PlusIcon from "@tCentro/Icons/PlusIcon";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type FieldRefs = {
    [key: string]: React.RefObject<HTMLElement>;
};
type Props = OwnProps &
    WidgetProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasParentProductId;

const mapStateToProps = (state: ApplicationState & CustomApplicationState, ownProps: HasParentProductId) => ({
    variantTraits: getProductState(state, ownProps.parentProductId).value?.variantTraits,
    variantChildren: getVariantChildrenDataView(state, ownProps.parentProductId).value,
    variantSelection: state.pages.productDetails.variantSelection,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    variantProductState: getProductState(state, state.pages.productDetails.selectedProductId),
    selectedProductId: state.pages.productDetails.selectedProductId,
    cenVariantClicked: state.t_components.cenVariantPdpAddToCartIsClicked.variantPdpAddToCartClicked,
});

const mapDispatchToProps = {
    updateVariantSelection,
    cenVariantPdpAddToCartClicked,
};

export interface ProductDetailsVariantOptionsStyles {
    wrapper?: InjectableCss;
    plusMinusIconStyles?: IconPresentationProps;
    iconContainerStyles?: InjectableCss;
    showMoreStyles?: InjectableCss;
    selectAllvaraintMsgStyles?: InjectableCss;
    variantErrContainer?: InjectableCss;
    variantErrStyles?: InjectableCss;
    ulStyles?: TypographyPresentationProps;
    unSelectedVariantStyles?: InjectableCss;
    alertIconStyles?: IconPresentationProps;
    variantDropDownStyles?: InjectableCss;
}

export const variantOptionsStyles: ProductDetailsVariantOptionsStyles = {
    variantDropDownStyles: {
        css: css`
            flex-basis: 48%;
            max-width: 48%;
            margin-top: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css``,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    alertIconStyles: {
        css: css`
            svg {
                height: 15.75px;
                width: 18px;
            }
        `,
    },
    ulStyles: {
        underline: true,
        css: css`
            list-style-type: disc;
            padding-left: 50px;
        `,
    },
    unSelectedVariantStyles: {
        css: css`
            font-family: Poppins;
            font-size: 14px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            cursor: pointer;
            text-decoration: underline;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    variantErrStyles: {
        css: css`
            font-family: Poppins;
            font-size: 14px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    variantErrContainer: {
        css: css`
            background-color: #ed000014;
            border-left: 8px solid #ed0000;
            padding: 16px 16px 16px 8px;
            margin-top: 24px;
            margin-bottom: 24px;
        `,
    },
    selectAllvaraintMsgStyles: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-size: ${TYPOGRAPHY.size.base};
            font-weight: ${TYPOGRAPHY.weight.base};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            text-align: left;
            margin-bottom: 24px;
        `,
    },
    iconContainerStyles: {
        css: css`
            display: flex;
            width: 100%;
            justify-content: flex-end;
            gap: 10px;
            align-items: center;
            padding-right: 24px;
            cursor: pointer;
        `,
    },
    showMoreStyles: {
        css: css`
            font-family: Poppins;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            text-align: left;
            color: ${getColor("text.link")};
            cursor: pointer;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
        `,
    },
    plusMinusIconStyles: {
        size: 10,
        css: css`
            svg {
                path {
                    stroke: #0f96d9;
                    fill: #0f96d9;
                }
            }
        `,
    },
};

const styles = variantOptionsStyles;

const ProductDetailsVariantOptions: React.FC<Props> = ({
    variantChildren,
    variantSelection,
    updateVariantSelection,
    variantTraits,
    parentProductId,
    variantProductState,
    selectedProductId,
    fields,
    cenVariantClicked,
    variantSelectionCompleted,
    cenVariantPdpAddToCartClicked,
}) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [unselectedVariantTraits, setUnselectedVariantTraits] = React.useState<VariantTraitModel[]>([]);

    const fieldRefs = React.useRef<FieldRefs>({});

    useEffect(() => {
        cenVariantPdpAddToCartClicked({
            variantPdpAddToCartClicked: false,
        });
    }, []);

    useEffect(() => {
        let newUrl = window.location.href;
        const optionIndex = newUrl.indexOf("option");
        if (optionIndex >= 0) {
            newUrl = window.location.href.substring(0, optionIndex - 1);
        }
        if (variantProductState.value && variantProductState.value.isVariantParent) {
            window.history.replaceState(null, "", newUrl);
        } else if (variantProductState.value && variantProductState.value.childTraitValues) {
            const separator = newUrl.indexOf("?") >= 0 ? "&" : "?";
            newUrl = newUrl.concat(`${separator}option=`, encodeURIComponent(variantProductState.value.productNumber));
            window.history.replaceState(null, "", newUrl);
        }
    }, [selectedProductId]);

    useEffect(() => {
        if (variantTraits) {
            const unselectedTraits = variantTraits.filter(trait => !variantSelection[trait.id]);
            setUnselectedVariantTraits(unselectedTraits);
        }
    }, [variantTraits, variantSelection]);

    const variantChangeHandler = (traitValueId: string, variantTraitId: string) => {
        updateVariantSelection({ traitValueId, variantTraitId, productId: parentProductId });
    };

    if (!variantTraits || variantTraits.length === 0 || !variantChildren) {
        return null;
    }

    const filteredVariantTraits = useFilteredVariantTraits(variantTraits, variantChildren, variantSelection, true);

    const handleLiCLick = (unselectedVariantId: string) => {
        const fieldRef = fieldRefs.current[unselectedVariantId];
        if (fieldRef && fieldRef.current) {
            fieldRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };
    const renderVariant = (variantTrait: VariantTraitModel) => {
        switch (variantTrait.displayType) {
            case VariantDisplayTypeValues.Button:
                return (
                    <ProductDetailsVariantButton
                        key={variantTrait.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={variantTrait}
                    />
                );
            case VariantDisplayTypeValues.SwatchDropdown:
                return (
                    <ProductDetailsVariantSwatchDropdown
                        key={variantTrait.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={variantTrait}
                    />
                );
            case VariantDisplayTypeValues.SwatchGrid:
                return (
                    <ProductDetailsVariantSwatchGrid
                        key={variantTrait.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={variantTrait}
                    />
                );
            case VariantDisplayTypeValues.SwatchList:
                return (
                    <ProductDetailsVariantSwatchList
                        key={variantTrait.id}
                        variantSelection={variantSelection}
                        updateVariantSelection={variantChangeHandler}
                        variantTrait={variantTrait}
                    />
                );
            default:
                fieldRefs.current[variantTrait.id] = React.createRef<HTMLElement>();
                return (
                    <StyledWrapper
                        ref={fieldRefs?.current?.[variantTrait?.id] as any}
                        key={variantTrait.id}
                        {...styles.variantDropDownStyles}
                    >
                        <ProductDetailsVariantDropdown
                            key={variantTrait.id}
                            variantSelection={variantSelection}
                            updateVariantSelection={variantChangeHandler}
                            variantTrait={variantTrait}
                        />
                    </StyledWrapper>
                );
        }
    };

    return (
        <>
            {!variantSelectionCompleted && (
                <StyledWrapper>
                    <Typography as="p" {...styles.selectAllvaraintMsgStyles}>
                        {siteMessage("Pdp_Parent_Variant_SelectAll_Msg")}
                    </Typography>
                    {cenVariantClicked && unselectedVariantTraits && unselectedVariantTraits.length > 0 && (
                        <StyledWrapper {...styles.variantErrContainer} className="errorSummaryContainer">
                            <StyledWrapper
                                css={css`
                                    display: flex;
                                `}
                            >
                                <Icon src={CustomAlertTriangleIcon} {...styles.alertIconStyles} />
                                <Typography as="p" {...styles.variantErrStyles}>
                                    {siteMessage("Pdp_Parent_Variant_Error_Msg")}
                                </Typography>
                            </StyledWrapper>
                            <Typography as="ul" {...styles.ulStyles}>
                                {unselectedVariantTraits.map((unselectedVariantTrait, index) => {
                                    return (
                                        <>
                                            <Typography
                                                as="li"
                                                {...styles.unSelectedVariantStyles}
                                                onClick={() => handleLiCLick(unselectedVariantTrait.id)}
                                            >
                                                Enter {unselectedVariantTrait.nameDisplay}
                                            </Typography>
                                        </>
                                    );
                                })}
                            </Typography>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            )}
            <StyledWrapper {...styles.wrapper}>
                {filteredVariantTraits.map(
                    variantTrait =>
                        !!variantTrait.traitValues?.length && renderVariant(variantTrait as VariantTraitModel),
                )}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsVariantOptions)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
